import { formatPosition } from './geometry';

export const reverseGeocode = (position) => {
    return new Promise((resolve) => {
        const geocoder = new google.maps.Geocoder();
        const options = { location: formatPosition(position) };
        geocoder.geocode(options, (results, status) => {
            if (status !== 'OK' || !results[0]) resolve([]);
            let parts = results?.[0]?.address_components.filter((addressComponent) => {
                return addressComponent.types.includes('political');
            });
            if (!parts?.length) {
                parts = results?.[1]?.address_components.filter((addressComponent) => {
                    return addressComponent.types.includes('political');
                });
            }

            parts = (parts || []).map((addressComponent) => addressComponent.short_name);
            //Google api returns an array of objects with the location of the field.
            //If it doesn´t find 'political' in the first element, the if searchs for 'political'
            //in the second option, which isn´t a location as accurate as the first one but
            // good enough to let the user create a field there
            resolve([...new Set(parts)]);
        });
    });
};
